import { type Image, type Media, type Video } from './types';
import { imagesMapper, videosMapper } from './utils';

interface Props {
	images: Image[];
	videos?: Video[] | null;
	contentVideos?: Video[] | null;
	showVideos?: boolean;
}

export const useCarouselMedia = ({
	images,
	videos,
	contentVideos,
}: Props): Media[] => {
	if (!images || images.length === 0) return [];

	const [firstImage, ...restImages] = images;
	const [productVideo, ...restProductVideos] = videos ?? [];

	const hasProductVideo = !!productVideo;
	const restProductMedia = videosMapper(restProductVideos, firstImage);
	const productMedia = hasProductVideo ? videosMapper([productVideo]) : [];

	return [
		...(firstImage ? imagesMapper([firstImage]) : []),
		...(hasProductVideo ? productMedia : []),
		...imagesMapper(restImages),
		...restProductMedia,
		...videosMapper(contentVideos, firstImage),
	];
};
